import React, { useState } from "react";
import { compose } from "redux";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { Xs, Md, withModal, withQuery } from "components/common";
import { DASHBOARD_QUERY, LOCKED_STATUS_QUERY } from "utils/mutations";
import { CARD_STATUS } from "utils/constants";
import { isUserRiskLocked } from "utils/utils";
import { track } from "../../../utils/analytics";
import CurrentBalance from "./CurrentBalance";
import AvailableCredit from "./AvailableCredit";
import Rewards from "./Rewards";
import NextPayment from "./NextPayment";
import StartEarning from "./StartEarning";
import YourTransactions from "./YourTransactions";
import Refer from "./Refer";
import ActivateCard from "./ActivateCard";
import VerifyEmail from "../VerifyEmail";
import CreditScore from "./CreditScore";
import PaymentForm from "../Payments/PaymentForm";
import OffersTile from "../Offers/OffersTile";
import PaymentAdditional from "../Payments/PaymentAdditional";

const classes = {
  row: "mt-3",
};

const containerHeight = "150px";

const CardDashboard = ({
  data: { user },
  history,
  modalContext: { isOpen: modalIsOpen, openModal, closeModal },
}) => {
  const [userDismissedModal, setUserDismissedModal] = useState(false);
  const [updateUserDashboardTermsAccepted] = useMutation(
    UPDATE_USER_DASHBOARD_TERMS_ACCEPTED,
  );
  const [didUserMakePayment, setUserMakePayment] = useState(false);

  if (
    !(user.application || {}).dashboard_terms_accepted &&
    !modalIsOpen &&
    !userDismissedModal
  ) {
    const dismiss = () => {
      track("DASHBOARD_ACCEPTED_TERMS");
      closeModal();
      setUserDismissedModal(true);
      updateUserDashboardTermsAccepted({
        variables: {
          application: { dashboard_terms_accepted: true },
        },
        onCompleted: () => {},
        update: (cache) => {
          cache.writeData({
            data: { user: { application: { dashboard_terms_accepted: true } } },
          });
        },
      })
        .then(() => {
          console.log("updated user dashboard terms accepted");
        })
        .catch(() => {
          console.log("failed to update user dashboard terms accepted");
        });
    };
    openModal(
      null,
      "GreetingApprovalModal",
      {
        dismiss,
        amount: user.credit ? user.credit.credit_limit : 0,
      },
      { showCloseButton: false },
    );
  }
  track("DASHBOARD_LOADED_MAIN_PAGE");

  const { data: userLockedStatus } = useQuery(LOCKED_STATUS_QUERY);
  const isRiskLocked = isUserRiskLocked(userLockedStatus?.userLockedStatus);
  const amountDue = -user.payment_due_balance;
  const locked = user.card?.status === CARD_STATUS.LOCKED;
  const lockedAndAmountDue = locked && amountDue > 0;

  return (
    <>
      {!user.is_email_verified ? (
        <VerifyEmail />
      ) : (
        <>
          <Xs to="md">
            <div className="flex flex-wrap">
              <CurrentBalance className="w-full" user={user} />
              <ActivateCard
                className="w-full mb-4"
                user={user}
                openModal={openModal}
                closeModal={closeModal}
              />
              {!isRiskLocked && (
                <AvailableCredit
                  className="flex w-1/2 mt-4 pr-2"
                  creditAvailable={
                    user.credit ? user.credit.credit_available || 0 : null
                  }
                  locked={locked}
                />
              )}
              <Rewards
                className={` ${
                  (isRiskLocked || locked) ? "flex-auto" : "flex w-1/2 pl-2"
                } mt-4`}
                rewards={user.rewards}
              />
              <OffersTile
                offers={user.offers}
                showOffers={user.showOffers}
                className="w-full mt-4"
              />
              <CreditScore className="w-full mt-4" />
              {lockedAndAmountDue ? (
                <div className="w-full mt-4">
                  <PaymentAdditional
                    className="flex w-full justify-center mt-4 md:mb-0 md:flex-auto md:mx-2 md:w-2/5"
                    user={user}
                  />
                  {/* <PaymentForm
                    className="w-full mt-4"
                    onDrawerClose={() => {
                      setUserMakePayment(true);
                    }}
                    user={user}
                    hideAutopayDescription
                  />
                  <PaymentAdditional 
                    className="w-full mt-4"
                    user={user}
                    hideAutopayDescription
                  /> */}
                </div>
              ) : (
                <>
                  {/* <NextPayment
                    className={`${classes.row} w-full`}
                    user={user}
                    onSuccessfulPayment={() => setUserMakePayment(true)}
                  /> */}
                  <PaymentAdditional
                    className="flex w-full justify-center mt-4 mb-2 md:mb-0 md:flex-auto md:mx-2 md:w-2/5"
                    user={user}
                  />
                  <Refer className={`${classes.row} w-full`} user={user} />
                  <StartEarning className={`${classes.row} w-full`} />
                </>
              )}
            </div>
          </Xs>
          <Md>
            <div className="flex flex-col self-center mx-auto">
              <ActivateCard
                className="w-full mb-4"
                user={user}
                openModal={openModal}
                closeModal={closeModal}
              />
              <div
                className="flex flex-row -mx-2 mb-4"
                style={{ minHeight: containerHeight }}
              >
                <CurrentBalance className="flex-auto px-2" user={user} />
                {!isRiskLocked && (
                  <AvailableCredit
                    className="flex-auto px-2"
                    creditAvailable={
                      user.credit ? user.credit.credit_available || 0 : null
                    }
                    locked={locked}
                  />
                )}
                <CreditScore className="flex-auto px-2" />
              </div>
              {lockedAndAmountDue ? (
                <div className="w-full flex mr-2 mb-4">
                  <PaymentAdditional
                    className="flex w-full mb-2 md:mb-0 md:flex-auto md:w-2/5"
                    user={user}
                  />
                  {/* <PaymentForm
                    className="flex mr-4 w-3/5"
                    onDrawerClose={() => {
                      setUserMakePayment(true);
                    }}
                    user={user}
                    hideAutopayDescription
                  /> */}
                  {/* <PaymentAdditional 
                    className="flex w-2/5"
                    user={user}
                    hideAutopayDescription
                  /> */}
                </div>
              ) : (
                <>
                  <div className="w-full flex mr-2 mb-4">
                    <PaymentAdditional
                      className="flex w-full justify-center mb-2 md:mb-0 md:flex-auto md:w-2/5"
                      user={user}
                    />
                  </div>
                  <div className="flex flex-row -mx-2 mb-2">
                    <div className="flex-col w-full">
                      <OffersTile
                        offers={user.offers}
                        showOffers={user.showOffers}
                        className="px-2 mb-4"
                      />
                      <Refer
                        className={`flex-auto px-2 ${
                          user.showOffers ? "" : "h-full"
                        }`}
                        user={user}
                        compact={user.showOffers}
                      />
                    </div>
                    {/* <NextPayment
                      className="flex px-2 w-1/4"
                      user={user}
                      onSuccessfulPayment={() => setUserMakePayment(true)}
                    /> */}
                  </div>
                </>
              )}
            </div>
          </Md>
          <YourTransactions
            className="mt-8"
            didUserMakePayment={didUserMakePayment}
            setUserMakePayment={setUserMakePayment}
          />
          <div className="text-center">
            <button
              type="button"
              className="btn"
              style={{ marginTop: 8 }}
              onClick={() => history.push("/activity")}
            >
              Show All
            </button>
          </div>
        </>
      )}
    </>
  );
};

const UPDATE_USER_DASHBOARD_TERMS_ACCEPTED = gql`
  mutation UpdateUser($application: UserApplicationInput!) {
    updateUser(application: $application) {
      application {
        dashboard_terms_accepted
      }
    }
  }
`;

export default compose(withModal, withQuery(DASHBOARD_QUERY))(CardDashboard);
